import { render, staticRenderFns } from "./packages-listing.vue?vue&type=template&id=ee4a6320&"
import script from "./packages-listing.vue?vue&type=script&lang=js&"
export * from "./packages-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports